<template>
  <van-nav-bar
    title="编辑"
    left-text="返回"
    left-arrow
    @click-left="$router.go(-1)"
  />
  <br />
  <div class="address_content">
    <van-form @submit="Login">
      <van-cell-group inset>
        <van-field
          v-model="addressModel.Name"
          name="姓"
          label="姓"
          placeholder="姓"
        />
        <van-field
          v-model="addressModel.LastName"
          name="名"
          label="名"
          placeholder="名"
        />

        <van-field
          v-model="addressModel.Phone"
          name="手机号"
          label="手机号"
          placeholder="手机号"
        />
        <van-field
          v-model="addressModel.Mailbox"
          name="邮箱"
          label="邮箱"
          placeholder="邮箱"
        />

        <!-- <van-field
          v-model="addressModel.Code"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <template #button>
            <van-button size="small" @click="ValidateEmail" type="primary"
              >发送验证码</van-button
            >
          </template>
        </van-field> -->

        <van-field
          v-model="addressValue"
          is-link
          readonly
          label="地区"
          placeholder="请选择所在地区"
          @click="ProvincesShow = true"
        />

        <van-action-sheet @select="ProvincesChange" :actions="Provinces" v-model:show="ProvincesShow" title="请选择省份">
          <!-- <div class="content">
            <van-picker

              :columns-field-names="{ text: 'cityName', children: 'cities' }"
              @confirm="ProvincesChange"
              @change="ProvincesChange"

            />
          </div> -->
        </van-action-sheet>

        <van-action-sheet v-model:show="CitysShow" @select="CitysChange" title="请选择市"  :actions="Citys" >
          <!-- <div class="content">
            <van-picker
              :columns="Citys"
              :columns-field-names="{ text: 'cityName', children: 'cities' }"
              @confirm="CitysChange"
              @change="CitysChange"
              @select="CitysChange"
            />
          </div> -->
        </van-action-sheet>

        <van-action-sheet v-model:show="AreasShow"  @select="AreasChange" title="请选择县" :actions="Areas">
          <!-- <div class="content">
            <van-picker
              :columns="Areas"
              :columns-field-names="{ text: 'cityName', children: 'cities' }"
              @confirm="AreasChange"
              @change="AreasChange"
              @select="AreasChange"
            />
          </div> -->
        </van-action-sheet>

        <van-action-sheet v-model:show="StreetssShow" title="请选择街道"   @select="StreetsChange" :actions="Streets">
          <!-- <div class="content">
            <van-picker
              :columns="Streets"
              :columns-field-names="{ text: 'cityName', children: 'cities' }"
              @confirm="StreetsChange"
              @change="StreetsChange"
              @select="StreetsChange"
            />
          </div> -->
        </van-action-sheet>

        <van-field
          v-model="addressModel.DetailedAddress"
          rows="2"
          autosize
          label="详细地址"
          type="textarea"
          maxlength="100"
          placeholder="请输入详细地址"
          show-word-limit
        />
        <van-field name="switch" label="默认地址">
          <template #input>
            <van-switch v-model="addressModel.Default" size="20" />
          </template>
        </van-field>
      </van-cell-group>

      <div style="margin: 16px">
        <p>
          <router-link to="register" />
        </p>
        <van-button
          @click="AddOrUpdate"
          round
          block
          type="primary"
          native-type="submit"
        >
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { Tag } from "vant"
import axios from "../../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  name: "header",
  data () {
    return {
      addressModel: {
        Default: false
      }, // 地址
      addressValue: "", // 选中地址
      addressOptions: [], // 地址集合
      addressShow: false,
      cascaderValue: "",
      ProvincesShow: false, // 显示省份
      CitysShow: false, // 显示市
      AreasShow: false, // 显示区
      StreetssShow: false, // 显示街道
      ProvinceCitys: [], // 省市联动数据
      Provinces: [], // 省份
      Citys: [], // 市的数据
      Areas: [], // 区县
      Streets: [], // 街道

      OptProvinces: {}, // 省份
      OptCitys: {}, // 市的数据
      OptAreas: {}, // 区县
      OptStreets: {}, // 街道

      AddressId: ""
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.AddressId = this.$route.query.id
    this.GetProvinceCity()
    this.GetAddress()
  },
  methods: {
    GetAddress () {
      if (this.AddressId == "add") {
        this.addressModel = {
          Default: false
        }
        return
      }

      var param = {
        Id: this.AddressId
      }
      axios.apiMethod(
        "/api/Address/GetMyAddressById",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            this.addressModel = result.Data
            this.addressValue =
              result.Data.ProvinceFormet +
              "/" +
              result.Data.CityFormet +
              "/" +
              result.Data.AreaFormet +
              "/" +
              result.Data.StreetFormet

            this.OptProvinces = { id: this.addressModel.Province }
            this.OptCitys = { id: this.addressModel.City }
            this.OptAreas = { id: this.addressModel.Area }
            this.OptStreets = { id: this.addressModel.Street }
          }
        }
      )
    },
    // 编辑地址
    EditAddress (item, index) {},
    // 完成选择
    // AddressFinish(item) {
    //   console.log(JSON.stringify(item));

    //   this.addressShow = false;
    //   this.addressValue = item.selectedOptions
    //     .map((option) => option.text)
    //     .join("/");
    //   console.log(JSON.stringify(this.cascaderValue));
    // },
    // 获取vant格式
    GetProvinceCityCategoryTree () {
      var param = {}
      axios.apiMethod(
        "/api/SystemConfiguration/GetProvinceCityCategoryTree",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            this.addressOptions = result.Data
          }
        }
      )
    },
    // 新增或者修改地址
    AddOrUpdate () {
      // OptProvinces: {}, //省份
      // OptCitys: {}, //市的数据
      // OptAreas: {}, //区县
      // OptStreets: {}, //街道
      this.addressModel.Province = this.OptProvinces.id
      this.addressModel.City = this.OptCitys.id
      this.addressModel.Area = this.OptAreas.id
      this.addressModel.Street = this.OptStreets.id

      axios.apiMethod(
        "/api/User/UpdateAddresInfo",
        "post",
        this.addressModel,
        (result) => {
          if (result.Code == 200) {
            if (result.Data) {
              this.$router.go(-1)

              showToast({
                message: "操作成功",
                type: "success"
              })
            } else {
              showToast({
                message: "操作失败",
                type: "error"
              })
            }
          }
        }
      )
    },
    // 获取省市联动数据
    GetProvinceCity () {
      axios.apiMethod(
        "/sys/SystemData/GetProvinceCitys",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.ProvinceCitys = result.Data
            this.Provinces = []
            this.ProvinceCitys.Provinces.forEach((element) => {
              this.Provinces.push({
                name: element.Name,
                id: element.Id
              })
            })

            this.OptProvinces = { id: this.addressModel.Province }
            this.OptCitys = { id: this.addressModel.City }
            this.OptAreas = { id: this.addressModel.Area }
            this.OptStreets = { id: this.addressModel.Street }
          }
        }
      )
    },
    // 选择省份
    ProvincesChange (currentValue) {
      this.ProvincesShow = false
      this.CitysShow = true
      this.Citys = []
      this.ProvinceCitys.Citys.forEach((element) => {
        if (element.Fid == currentValue.id) {
          this.Citys.push({
            name: element.Name,
            id: element.Id
          })
        }
      })
      this.OptProvinces = currentValue
    },
    // 选择市
    CitysChange (currentValue) {
      this.CitysShow = false
      this.AreasShow = true

      this.Areas = []
      this.ProvinceCitys.Areas.forEach((element) => {
        if (element.Fid == currentValue.id) {
          this.Areas.push({
            name: element.Name,
            id: element.Id
          })
        }
      })

      this.OptCitys = currentValue
    },
    // 选择县
    AreasChange (currentValue) {
      this.AreasShow = false
      this.StreetssShow = true

      this.Streets = []
      this.ProvinceCitys.Streets.forEach((element) => {
        if (element.Fid == currentValue.id) {
          this.Streets.push({
            name: element.Name,
            id: element.Id
          })
        }
      })
      this.OptAreas = currentValue
    },
    // 选择县
    StreetsChange (currentValue) {
      this.StreetssShow = false
      this.OptStreets = currentValue

      this.addressValue =
        this.OptProvinces.name +
        "/" +
        this.OptCitys.name +
        "/" +
        this.OptAreas.name +
        "/" +
        this.OptStreets.name
    }
  }
}
</script>
<style  lang="scss"  scoped>
</style>
